import { render } from "./FileBrowserPath.vue?vue&type=template&id=071b4b04&scoped=true"
import script from "./FileBrowserPath.vue?vue&type=script&lang=js"
export * from "./FileBrowserPath.vue?vue&type=script&lang=js"

import "./FileBrowserPath.vue?vue&type=style&index=0&id=071b4b04&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071b4b04"]])

export default __exports__